import _extends from "@babel/runtime/helpers/extends";
export var CLASSIC_BORDER_RADIUS = {
  SMALL: '2px',
  MEDIUM: '4px',
  LARGE: '6px'
};
export var MODERN_BORDER_RADIUS = {
  SMALL: '2px',
  MEDIUM: '4px',
  LARGE: '6px'
};
var loop = fn => {
  Object.keys(CLASSIC_BORDER_RADIUS).map(k => fn(k, "--wdn_10_" + k.toLocaleLowerCase() + "_border_radius"));
  Object.keys(CLASSIC_BORDER_RADIUS).map(k => fn(k, "--wdn_" + k.toLocaleLowerCase() + "_border_radius"));
};
export var CLASSIC_BORDER_RADIUS_VARS = [];
export var MODERN_BORDER_RADIUS_VARS = [];
export var BORDER_RADIUS = _extends({}, CLASSIC_BORDER_RADIUS);
loop((name, varName) => CLASSIC_BORDER_RADIUS_VARS.push([varName, CLASSIC_BORDER_RADIUS[name]]));
loop((name, varName) => MODERN_BORDER_RADIUS_VARS.push([varName, MODERN_BORDER_RADIUS[name]]));
loop((name, varName) => BORDER_RADIUS[name] = "var(" + varName + ")");
//# sourceMappingURL=border-radius.js.map